module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-02.eeb9c7e5.png";